import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class AuthService {
    getCurrentUser() {
      return { id: 1, username: 'kingkong', role: 'admin' };
    }
  }
  